import React, { useEffect, useState, Fragment } from 'react'
import {Button, Card, Col, Container, Form, Row, Modal} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import {FaSearch} from 'react-icons/fa'
import { formato_monto, isValidParam } from '../../common/Formatos'
import { CarpetaDigitalComponent } from '../..'
import { LoadingComponent } from 'recupero-comunes'
import { serviceGetDocumento } from '../../api/api-declaracion-pago';

const PagoCuotas = ({handleClose}) => {

  const [loading, setLoading]= useState(false)

   const [showCarpeta, setShowCarpeta] = useState(false)
   const data_recepciona = useSelector((state) => state.casoGeneralReducer)
   const { llaves} = data_recepciona
   const data_decPago = useSelector((state) => state.declaracionPagoReducer)
   const { cfg_form85, datosDecPago} = data_decPago
   const [idFolioDocumento, setFolioDocumento] = useState(null);

   const handleShowCarpeta = () => setShowCarpeta(true)
   const handleCloseCarpeta= () => setShowCarpeta(false)

   const [formaPago, setFormaPago ]=useState('')
   const [recobroCuotas, setRecobroCuotas ]=useState('')

  useEffect(() => {
    if (datosDecPago && datosDecPago?.datosDecPago['idFolioCargaReciboPago']) {
      setFolioDocumento(datosDecPago?.datosDecPago['idFolioCargaReciboPago']);
    }
  }, [datosDecPago]);

  const verDocumento = async (folioDocumento) => {
    console.log("in handleDocumento...");
    
    try {        
      if (folioDocumento) {
        setLoading(true); 
        let parametros = JSON.stringify({
            idCaso: (llaves && llaves['idCaso']),
            idImplicadoCaso: (llaves && llaves['idImplicado']),
            idCompania: (llaves && llaves['idOrgCaso']),
            idfolioCarga: folioDocumento
        })

        console.log("params handleDocumento...", parametros);
        let query = Buffer.from(parametros).toString('base64')

        const response = await serviceGetDocumento(query);
        setLoading(false);

        var link = document.createElement("a");
        link.download = response.filename;
        link.href = "data:" + response.mimetype + ";base64," + response.file;
        link.click();
      }
    } catch (error) {
      console.log("error:", error);
      setLoading(false);
    }
  }

   return (
       <>
    <style type='text/css'>
    {`
       .btn-carpeta {
           background-color: #F0AD3E;
           color: #FFFFFF;
           width: 140px;
           
         }
         .btn-carpeta:hover{
             background-color:#e1b97f;
             color: #FFFFFF;
     
         }    
    `}
       </style>
       <Modal show={showCarpeta} onHide={handleCloseCarpeta} size="xl">      
           
           <CarpetaDigitalComponent handleClose={handleCloseCarpeta} 
             idCaso={llaves && llaves['idCaso']}
             idImplicado={llaves && llaves['idImplicado']}
             idOrganizacionCaso={llaves && llaves['idOrgCaso']}
             prototipo={2}               
            />             
       </Modal>
        <LoadingComponent show={loading}/>
        <Container> 
            <Card >
              <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>
                {cfg_form85 ? cfg_form85.cfg_form85['modaldeclaracionpagorecobro-title'] : ''} 
              </Card.Header>
              <div style={{border:'2px solid #4F517A', marginTop:'10px', borderRadius:'10px', marginLeft:'10px', marginRight:'10px'}} >
                <Container>
                    <Row >
                      <Col >
                        <Form.Label className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '16px' }}>
                          {cfg_form85 ? cfg_form85.cfg_form85['modaldeclaracionpagorecobro-lbl-moneda'] : ''}  
                        </Form.Label>
                        <br />
                        <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                          { isValidParam(datosDecPago?.datosDecPago['moneda']) ? datosDecPago?.datosDecPago['moneda'] : '' }  
                        </Form.Text>
                      </Col>
                      <Col >
                        <Form.Label className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '16px' }}>
                          {cfg_form85 ? cfg_form85.cfg_form85['modaldeclaracionpagorecobro-lbl-mtorecobro'] : ''}  
                        </Form.Label>
                        <br />
                        <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                          { isValidParam(datosDecPago?.datosDecPago['montoRecobro']) ? formato_monto(datosDecPago?.datosDecPago['montoRecobro']) : '' }  
                        </Form.Text>
                      </Col>
                      <Col >
                        <Form.Label className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '16px' }}>
                          {cfg_form85 ? cfg_form85.cfg_form85['modaldeclaracionpagorecobro-chk-pagocuotas'] : ''}  
                        </Form.Label>
                      </Col>
                    </Row>
                    <Row>                                          
                        <Col md='12' xl='12' sm='8' lg='12'>                    
                          <hr style={{ color: '#04005D', height: '2px', marginTop:'30px' }}></hr>
                        </Col>
                    </Row>
                    <Row >
                      <Col >
                        <Form.Label className='mb-3' style={{ fontWeight: 'bold', fontSize: '16px' }}>
                          {cfg_form85 ? cfg_form85.cfg_form85['modaldeclaracionpagorecobro-lbl-convpago'] : ''}  
                        </Form.Label>
                        <br />
                        <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                          { isValidParam(datosDecPago?.datosDecPago['idConvenio']) ? datosDecPago?.datosDecPago['idConvenio'] : '' }  
                        </Form.Text>
                      </Col>
                      <Col >
                        <Form.Label className='mb-3' style={{ fontWeight: 'bold', fontSize: '16px' }}>
                          {cfg_form85 ? cfg_form85.cfg_form85['modaldeclaracionpagorecobro-lbl-mtopagopie'] : ''}  
                        </Form.Label>
                        <br />
                        <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                          { isValidParam(datosDecPago?.datosDecPago['montoPagoPie']) ? formato_monto(datosDecPago?.datosDecPago['montoPagoPie']) : '' }  
                        </Form.Text>
                      </Col>
                      <Col >
                        <Form.Label className='mb-3' style={{ fontWeight: 'bold', fontSize: '16px' }}>
                          {cfg_form85 ? cfg_form85.cfg_form85['modaldeclaracionpagorecobro-lbl-cntcuotas'] : ''}  
                        </Form.Label>
                        <br />
                        <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                          { isValidParam(datosDecPago?.datosDecPago['nroCuotas']) ? datosDecPago?.datosDecPago['nroCuotas'] : '' }  
                        </Form.Text>
                      </Col>
                      <Col >
                        <Form.Label className='mb-3' style={{ fontWeight: 'bold', fontSize: '16px' }}>
                          {cfg_form85 ? cfg_form85.cfg_form85['modaldeclaracionpagorecobro-lbl-fecprimpago'] : ''}  
                        </Form.Label>
                        <br />
                        <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                          { isValidParam(datosDecPago?.datosDecPago['fechaPrimerPagoFormat']) ? datosDecPago?.datosDecPago['fechaPrimerPagoFormat'] : '' }  
                        </Form.Text>
                      </Col>
                      <Col >
                        <Form.Label className='mb-3' style={{ fontWeight: 'bold', fontSize: '16px' }}>
                          {cfg_form85 ? cfg_form85.cfg_form85['modaldeclaracionpagorecobro-lbl-fecultpago'] : ''}  
                        </Form.Label>
                        <br />
                        <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                          { isValidParam(datosDecPago?.datosDecPago['fechaUltimoPagoFormat']) ? datosDecPago?.datosDecPago['fechaUltimoPagoFormat'] : '' }  
                        </Form.Text>
                      </Col>
                      <Col >
                        <Form.Label className='mb-3' style={{ fontWeight: 'bold', fontSize: '16px' }}>
                          {cfg_form85 ? cfg_form85.cfg_form85['modaldeclaracionpagorecobro-lbl-recobcuotas'] : ''}  
                        </Form.Label>
                        <br />
                        <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                          { isValidParam(datosDecPago?.datosDecPago['totalCuotas']) ? formato_monto(datosDecPago?.datosDecPago['totalCuotas']) : '' }  
                        </Form.Text>
                      </Col>
                    </Row>
                    <Row>                                          
                        <Col md='12' xl='12' sm='8' lg='12'>                    
                          <hr style={{ color: '#04005D', height: '2px', marginTop:'30px' }}></hr>
                        </Col>
                    </Row>
                    <Row >
                      <Col >
                        <Form.Label className='mb-3' style={{ fontWeight: 'bold', fontSize: '16px' }}>
                          {cfg_form85 ? cfg_form85.cfg_form85['modaldeclaracionpagorecobro-lbl-mtopagadopie'] : ''}  
                        </Form.Label>
                        <br />
                        <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                          { isValidParam(datosDecPago?.datosDecPago['montoPagoPie']) ? formato_monto(datosDecPago?.datosDecPago['montoPagoPie']) : '' }  
                        </Form.Text>
                      </Col>
                      <Col >
                        <Form.Label className='mb-3' style={{ fontWeight: 'bold', fontSize: '16px' }}>
                          {cfg_form85 ? cfg_form85.cfg_form85['modaldeclaracionpagorecobro-lbl-fecrend'] : ''}  
                        </Form.Label>
                        <br />
                        <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                          { isValidParam(datosDecPago?.datosDecPago['fechaPagoPieFormat']) ? datosDecPago?.datosDecPago['fechaPagoPieFormat'] : '' }  
                        </Form.Text>
                      </Col>
                      <Col >
                        <Form.Label className='mb-3' style={{ fontWeight: 'bold', fontSize: '16px' }}>
                          {cfg_form85 ? cfg_form85.cfg_form85['modaldeclaracionpagorecobro-lbl-mediopago'] : ''}  
                        </Form.Label>
                        <br />
                        <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                          { isValidParam(datosDecPago?.datosDecPago['medioPagoPie']) ? datosDecPago?.datosDecPago['medioPagoPie'] : '' }  
                        </Form.Text>
                      </Col>
                      <Col >
                        <Form.Label className='mb-3' style={{ fontWeight: 'bold', fontSize: '16px' }}>
                          {cfg_form85 ? cfg_form85.cfg_form85['modaldeclaracionpagorecobro-lbl-bco'] : ''}  
                        </Form.Label>
                        <br />
                        <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                          { isValidParam(datosDecPago?.datosDecPago['banco']) ? datosDecPago?.datosDecPago['banco'] : '' }  
                        </Form.Text>
                      </Col>
                      <Col >
                        <Form.Label className='mb-3' style={{ fontWeight: 'bold', fontSize: '16px' }}>
                          {cfg_form85 ? cfg_form85.cfg_form85['modaldeclaracionpagorecobro-lbl-chequetrx'] : ''}  
                        </Form.Label>
                        <br />
                        <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                          { isValidParam(datosDecPago?.datosDecPago['nroChequeTrans']) ? datosDecPago?.datosDecPago['nroChequeTrans'] : '' }  
                        </Form.Text>
                      </Col>
                      <Col >
                        <Form.Label className='mb-3' style={{ fontWeight: 'bold', fontSize: '16px' }}>
                          {cfg_form85 ? cfg_form85.cfg_form85['modaldeclaracionpagorecobro-lbl-estado'] : ''}  
                        </Form.Label>
                        <br />
                        <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                          { isValidParam(datosDecPago?.datosDecPago['estado']) ? datosDecPago?.datosDecPago['estado'] : '' }  
                        </Form.Text>
                      </Col>
                      <a 
                        href="javascript:void(0);"
                        onClick={(e) => {
                          e.preventDefault();
                          if (!idFolioDocumento) {                                
                              return;
                          }
                          verDocumento(idFolioDocumento); 
                        }} 
                        style={{ display: 'flex', alignItems: 'center', marginTop: '10px', 
                            color: !idFolioDocumento ? 'gray' : 'red',
                            pointerEvents: !idFolioDocumento ? 'none' : 'auto',
                            opacity: !idFolioDocumento ? 0.5 : 1
                        }}
                      >
                        {/* SVG como ícono */}
                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-file-earmark-pdf" viewBox="0 0 20 20">
                          <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/>
                          <path d="M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z"/>
                        </svg>
                      </a>
                    </Row>
                    <Row><Col><br></br></Col></Row>
                </Container>
              </div>
              <Row >
                <Col className='d-flex align-items-end justify-content-end m-2'>
                  <Button className='m-2 w-auto' variant='outline-info' onClick={handleClose}>
                    {cfg_form85 && cfg_form85.cfg_form85["modaldeclaracionpagorecobro-btn-cerrar"]}                  
                  </Button>
                </Col>
              </Row>
            </Card>
        </Container>                   
        <br />
</>
)
}
export default PagoCuotas
             